import { memo, useEffect, useState } from 'react'
import Cookies from 'js-cookie'
import { useDispatch } from 'react-redux'
import { profileData } from '../../../features/auth/apis/authSlice'

import Navbar from './Navbar'
import FooterUpper from './FooterUpper'
import FooterLower from './FooterLower'
import Loading from '../../shared-components/Loading'

const Layout = ({ children }) => {
	const dispatch = useDispatch()
	const [isloaded, setIsLoaded] = useState(false)

	useEffect(() => {
		setIsLoaded(true)
	}, [])

	useEffect(() => {
		if (
			Cookies.get('SMARTCAF_USER_JWT_TOKEN') &&
			!localStorage.getItem('SMARTCAF-AUTH-USER')
		) {
			dispatch(profileData())
		}
	}, [dispatch])

	return (
		<>
			{!isloaded ? (
				<Loading classes='!h-screen' />
			) : (
				<>
					{/* <Chat /> */}

					<Navbar />
					<main className='overflow-x-hidden'>{children}</main>

					<FooterUpper />
					<FooterLower />
					{/* <FloatButton.BackTop
            type='primary'
            className='w-[40px] h-[64px] rounded-[32px]'
            style={{ bottom: 100, right: 40 }}
            icon={<Arrow color='white' style='mx-auto' />}
          /> */}
				</>
			)}
		</>
	)
}

export default memo(Layout)
